import {callBackendApi} from "../../../components/service/axios";

export const createPolicy = async (name: string,
                                   group: {
                                       type: string,
                                       id?: string,
                                       typeId?: string
                                   },
                                   systemResources: string[],
                                   scope: { name: string | undefined },
                                   actionNames: string[]) => {
    return await callBackendApi("post", "/bff/policies", {
        name: name,
        group: group,
        systemResources: systemResources,
        scope: scope,
        actionNames: actionNames
    });
};

export const editPolicy = async (name: string,
    group: {
        type: string,
        id?: string,
        typeId?: string
    },
    systemResources: string[],
    scope: { name: string | undefined },
    actionNames: string[],
    policyId: string
) => {
    return await callBackendApi("patch", `/bff/policies/${policyId}`, {
        name: name,
        group: group,
        systemResources: systemResources,
        scope: scope,
        actionNames: actionNames
    });
};

export const getPolicyInputRequirements = async ( policyId?: string) => {
  return await callBackendApi("get", `/bff/policies/input-requirements?policyId=${policyId}`, {});
};